import { Environments } from "@/config/env";

const env = import.meta.env ?? {};

export const API_BASE_URL = env.VITE_API_URL || "http://localhost:8000";
export const GOOGLE_CLIENT_ID = env.VITE_GOOGLE_CLIENT_ID || "";
export const MERCHANT_API = env.VITE_MERCHANT_API || "";
export const APPSFLYER_ONELINK_URL = env.VITE_APPSFLYER_ONELINK_URL || "";
export const CONFIGS_BASE_URL =
  env.VITE_CONFIGS_BASE_URL || "https://media-cdn.playme.studio/quiz-configs/dualio";

type ConfigEnvFolder = "prod" | "stage" | "dev";

export const resolveConfigEnvFolder = (): ConfigEnvFolder => {
  const current = env.VITE_ENVIRONMENT as Environments | undefined;
  switch (current) {
    case Environments.PRODUCTION:
      return "prod";
    case Environments.STAGE:
      return "stage";
    default:
      return "dev";
  }
};
